export default __webpack_public_path__ + "static/media/ev-charge-point.4cf7984e.svg";